import React, { useRef, useState } from "react";

import CopyButton from "@FillInTableContainer/shared/components/CopyButton/CopyButton";

type Props = {
  textValue: string;
  isDisableEdit?: boolean;
};

const AIAdvisorCellCopyButton = ({ textValue, isDisableEdit }: Props) => {
  const [copyStatus, setCopyStatus] = useState<"default" | "success" | "error">(
    "default",
  );

  const copyTimeoutRef = useRef<NodeJS.Timeout | null>(null);

  const copyCurrentTextValue = async (
    copyText: string,
    event: React.MouseEvent<HTMLButtonElement>,
  ) => {
    event.stopPropagation();
    event.preventDefault();

    try {
      await navigator.clipboard.writeText(copyText);
      setCopyStatus("success");

      copyTimeoutRef.current = setTimeout(() => {
        setCopyStatus("default");
      }, 1000);
    } catch (error) {
      setCopyStatus("error");

      copyTimeoutRef.current = setTimeout(() => {
        setCopyStatus("default");
      }, 1000);
    }
  };

  return (
    <CopyButton
      copyStatus={copyStatus}
      copyCurrentTextValue={(event) => copyCurrentTextValue(textValue, event)}
      isDisableEdit={isDisableEdit}
    />
  );
};

export default AIAdvisorCellCopyButton;
